import { State } from 'redux/utils/List'

export default State({}, {
    isPageable: false,
    isSortable: false,
    isFilterable: true
})
